import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ElprisApi = lazy(() => import("@/pages/ElprisApi"));

export const Route = createFileRoute("/elpris-api")({
  head: () => seoHead("/elpris-api"),
  component: () => <ElprisApi />,
});
